import styled from "@emotion/styled";
import React from "react";

import { ResponsiveIcon } from "@brexhq/next/src/components/shared/Icon";

const Button = styled.button(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  color: theme.colors.content.primary,
  padding: 0,
}));

interface Props {
  onClick: () => void;
}

export default function MenuButton({ onClick }: Props) {
  return (
    <Button aria-label="Open menu" onClick={() => onClick()}>
      <ResponsiveIcon
        icon="MenuOpen"
        responsive={{
          LRG: { height: 12 },
          MED: { height: 12 },
          SML: { height: 12 },
        }}
      />
    </Button>
  );
}
